import { AlertProps } from '@anm/components/notification/Alert';
import getFromCdn from '@anm/helpers/getFromCdn';
import { flexCenter } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { AlertTextPosition, AlertVariant } from '.';

const textPositions: { [key in AlertTextPosition]: ReturnType<typeof css> } = {
  left: css`
    align-items: flex-start;
  `,
  right: css`
    align-items: flex-end;
  `,
  center: css`
    ${flexCenter};
  `
};

const variants: { [key in AlertVariant]: ReturnType<typeof css> } = {
  info: css`
    color: #0c5460;
    background-color: #e1f9ff;
    border-color: rgba(1, 83, 130, 0.2);
  `,
  dark: css`
    color: #1b1e21;
    background-color: #d6d8d9;
    border-color: #c6c8ca;
  `,
  light: css`
    color: #818182;
    background-color: #fefefe;
    border-color: #fdfdfe;
  `,
  danger: css`
    color: var(--error);
    background-color: var(--error_bkg);;
    border-color: #f5c6cb;

    ${({ isIcon }: AlertProps) =>
      isIcon &&
      css`
        &:before {
          display: block;
          content: '';
          width: 30px;
          height: 30px;
          flex-shrink: 0;
          margin-right: 15px;
          background: url(${getFromCdn('images/icons/error_icon_v2.svg')}) no-repeat center / contain;
        }
      `}
  `,
  success: css`
    color: #417505;
    background-color: #dbf4d8;
    border-color: #c3e6cb;
  `,
  warning: css`
    color: #856404;
    background-color: #fff4db;
    border-color: #fcbd26;

    ${({ isIcon }: AlertProps) =>
      isIcon &&
      css`
        &:before {
          display: block;
          content: '';
          width: 30px;
          height: 30px;
          flex-shrink: 0;
          margin-right: 15px;
          background: url(${getFromCdn('images/icons/warning_icon.svg')}) no-repeat center / contain;
        }
      `}
  `
};

export const Wrapper = styled.div<AlertProps>`
  display: flex;
  padding: 0.75rem 1.25rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  align-items: center;
  flex-direction: column;
  &:empty {
    display: none;
  }

  ${({ variant }) => variants[variant]};
  ${({ position }) => textPositions[position]};
`;

export default Wrapper;
